const clearTooltip = (tooltip) => {
  tooltip.innerHTML = '';
};

const initTooltips = () => {
  const toggletips = document.querySelectorAll( '[data-toggletip-content]' );

  if (!toggletips || toggletips.length === 0) {
    return;
  }

  [...toggletips].forEach( toggletip => {
    const randomId = 'toggletip-' + Math.random().toString( 36 ).substr( 2, 9 );
    toggletip.setAttribute( 'aria-describedby', randomId );
    toggletip.setAttribute( 'aria-expanded', 'false' );

    const message = toggletip.getAttribute( 'data-toggletip-content' );
    const liveRegion = toggletip.nextElementSibling;

    if (liveRegion) {
      liveRegion.id = randomId;
      liveRegion.setAttribute( 'role', 'tooltip' );
    }

    toggletip.addEventListener( 'click', () => {
      clearTooltip( liveRegion );
      toggletip.setAttribute( 'aria-expanded', 'true' );
      liveRegion.innerHTML = '<span class="toggletip-bubble">' + message + '</span>';
    } );

    document.addEventListener( 'click', (e) => {
      if (toggletip !== e.target) {
        clearTooltip( liveRegion );
        toggletip.setAttribute( 'aria-expanded', 'false' );

      }
    } );

    toggletip.addEventListener( 'keydown', (e) => {
      if ((e.keyCode || e.which) === 27) {
        clearTooltip( liveRegion );
        toggletip.setAttribute( 'aria-expanded', 'false' );

      }
    } );

    toggletip.addEventListener( 'blur', (e) => {
      clearTooltip( liveRegion );
      toggletip.setAttribute( 'aria-expanded', 'false' );
    } );
  } );
};

export default initTooltips;